import { SchoolPage } from "@outschool/gql-backend-generated";
import {
  QueryHookOptions,
  gql,
  useQueryWithPreviousData
} from "@outschool/ui-apollo";

const SchoolPageQuery = gql`
  query SchoolPage($slug: String!) {
    schoolPage(slug: $slug) {
      uid
      slug
      name
      basePath
      searchFilters {
        age
        delivery
        dow
        endBy
        endByTime
        format
        languageOfInstruction
        order
        pricePerMeetingMax
        pricePerMeetingMin
        q
        multiTermQuery
        adminTags
        startAfter
        startAfterTime
        theme
        timeZone
        capacityMax
        gradeLevel
      }
      address
      city
      state
      startGrade
      endGrade
      schoolLevel
    }
  }
`;

export const useSchoolPageQuery = (
  slug: string,
  options?: QueryHookOptions
) => {
  return useQueryWithPreviousData<{
    schoolPage: SchoolPage;
  }>(SchoolPageQuery, {
    variables: { slug },
    ...{ ...options, skip: !slug }
  });
};
